<template>
  <div class="cn-about-card-text">
    <h3 class="cn-about-card-text__title" v-html="title" />
    <p class="cn-about-card-text__description" v-html="description" />
  </div>
</template>

<script setup lang="ts">
interface Props {
  title?: string;
  description?: string;
}
withDefaults(defineProps<Props>(), {
  title: '',
  description: '',
});
</script>
<style lang="scss">
.cn-about-card-text {
  --ab-canyon-about-card-text-title-color-text: var(--ab-canyon-color-primary);
  --ab-canyon-about-card-text-description-color-text: var(
    --ab-canyon-color-neutral-dark
  );

  padding-top: var(--size-3xl);
  padding-bottom: var(--size-3xl);

  @media (min-width: 656px) {
    padding-top: 0px;
    padding-bottom: 0px;
  }

  &__title {
    color: var(--ab-canyon-about-card-text-title-color-text);

    text-transform: uppercase;
    font-weight: 700;
    font-size: var(--text-lg-font-size);
    line-height: var(--text-lg-line-height);
    @media (min-width: 656px) {
      font-size: 1.25rem;
      line-height: var(--text-lg-line-height);
    }
    @media (min-width: 1280px) {
      font-size: 1.5rem;
      line-height: 2rem;
    }
  }
  &__description {
    color: var(--ab-canyon-about-card-text-description-color-text);

    line-height: 1.625;
    margin-top: var(--size-base);
  }
}
</style>
